<header>
  <dx-toolbar class="header-toolbar">
    @if (menuToggleEnabled()) {
      <dxi-toolbar-item
        location="before"
        widget="dxButton"
        cssClass="menu-button"
        [options]="{
          icon: 'menu',
          stylingMode: 'text',
          onClick: toggleMenu,
        }"
      />
    }
    <dxi-toolbar-item location="before" cssClass="header-title">
      <div *dxTemplate="let _ of 'title'" style="display: flex; align-items: center; gap: 0.5rem">
        <img
          ngSrc="logos/firmfirst-icon.svg"
          width="28"
          height="28"
          alt=""
          priority
          style="margin-left: 0.5em"
        />
        {{ appTitle() }}
      </div>
    </dxi-toolbar-item>
    <dxi-toolbar-item
      location="after"
      widget="dxButton"
      [options]="{
        icon: 'help',
        stylingMode: 'text',
        hint: 'Help',
        onClick: onHelpClick,
      }"
    />

    @if (user()) {
      <dxi-toolbar-item
        location="after"
        widget="dxButton"
        [options]="{
          icon: 'bell',
          stylingMode: 'text',
          hint: 'Notifications',
          onClick: onNotificationsClick,
        }"
      />
    }

    @if (user()) {
      <dxi-toolbar-item location="after" locateInMenu="auto" menuItemTemplate="menuItem">
        <div *dxTemplate="let data of 'item'">
          @defer (on viewport) {
            <app-user-panel [menuItems]="userMenuItems" />
          } @placeholder {
            <div class="user-panel-placeholder"></div>
          }
        </div>
      </dxi-toolbar-item>
    }

    <div *dxTemplate="let data of 'menuItem'">
      @defer (on viewport) {
        <app-user-panel [menuItems]="userMenuItems" menuMode="list" />
      } @placeholder {
        <div class="user-panel-list-placeholder"></div>
      }
    </div>
  </dx-toolbar>
</header>
